import styled from "styled-components";
import { TextColorNames } from "@smartsuite/types";
import { Textarea } from "@smartsuite/react-ui/lib";

export const StyledDescriptionContainer = styled.div`
  position: relative;
  padding-top: 0px;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: ${TextColorNames.secondary};

  input {
    padding: 0px;
    padding-top: 5px;
  }
  .hover-controls {
    padding-top: 18px;
  }
`;

export const TextAreaStyled = styled(Textarea)`
  max-width: 822px;
  font-size: 15px;
  line-height: 18px;
  color: ${TextColorNames.tertiary};
  padding: 0;
  border-radius: 0;
  word-break: break-word;
`;
